import styled from 'styled-components';
import {
  FormControl,
  InputLabel,
  Typography,
  Icon,
  Select,
  Checkbox,
  MenuItem
} from '@material-ui/core';
import { MuiBox } from 'theme/material-ui';
import Button from '@material-ui/core/Button';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Color } from 'modules/styles/colors';
import { InputField } from 'components/UI/Input/TextInput';
import { PreRegInputBase, standardHeight, standardWidth } from '../styled';
import MaskedInput from 'react-text-mask';

export const PersonalInfoFormControl = styled(FormControl)`
  background-color: ${Color.blueHue5};
  border-radius: 3px;
  ${standardWidth}
`;

export const PersonalInfoInputLabel = styled(InputLabel)`
  margin: 1rem 0 0.5rem 0;
`;

export const PersonalInfoInputLabelAddress = styled(InputLabel)`
  margin: 2.5rem 0 0.5rem 0;
  font-weight: 500;
  color: black;
`;

export const PersonalInfoSection = styled(MuiBox)`
  display: flex;
  flex-direction: row;
`;

export const MuiRow = styled(MuiBox)`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const MuiStacked = styled(MuiBox)`
  display: flex;
  flex-direction: column;
`;

export const PrefDropdown = styled(PreRegInputBase)`
  padding-left: 1.75rem;
  ${standardHeight}
`;

export const PreRegInputBox = styled(InputField)`
  padding-left: 1.75rem;
  background-color: ${Color.grayLight3};
  border-color: ${Color.grayLight};
  border-width: thin;
  ${standardHeight}
`;

export const MaskedPreRegInput = styled(MaskedInput)`
  padding-left: 1.75rem;
  background-color: ${Color.grayLight3};
  border-color: ${Color.grayLight};
  border-width: thin;
  border-style: solid;
  ${standardHeight}
`;

export const MuiMaskContainer = styled.div`
  position: relative;
`;

export const PhoneIcon = styled(Icon)`
  position: absolute;
  z-index: 99;
  overflow: visible;
  margin-top: 12px;
  margin-left: 3px;
`;

export const CheckBoxDiv = styled.div`
  padding-right: 15px;
`;

export const SectionHeader = styled(Typography)`
  padding: 0;
  font-weight: 600;
  font-size: medium;
`;

export const RequiredText = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

export const RedText = styled.p`
  color: red;
  margin: 0;
  padding-left: 0.25rem;
`;

export const Heading = styled(Typography)`
  padding: 0;
`;

export const ContactHeader = styled(Typography)`
  padding-top: 2rem;
  font-weight: 600;
  font-size: medium;
`;

export const DisplayAddress = styled.div`
  padding-left: 1.75rem;
  background-color: ${Color.grayLight3};
  border-color: ${Color.grayLight};
  border-width: thin;
  border-style: solid;
  ${standardWidth}
`;

export const DisplayEmail = styled(Typography)`
  margin-left: 0.5rem;
`;

export const DialogPopUp = styled.div`
  height: 35rem;
  padding: 1.5rem;
  min-width: 24rem;
`;

export const SearchBarSection = styled.div`
  display: flex;
  flex-direction: row;
  width: 80%vw;
`;

export const CancelButton = styled(Button)`
  color: primary;
  padding: 0;
`;

export const StyledAutoComplete = styled(Autocomplete)`
  & svg.search-icon {
    position: absolute;
    top: 0.75rem;
    left: 0.5rem;
  }
  && > div > div {
    ${standardHeight}
    width: 20rem;
    border-radius: 1.5rem;
    position: relative;
    & input {
      margin-top: -0.5rem;
      padding-left: 2rem !important;
    }
  }
`;

export const SearchPopUpHeader = styled(Typography)`
  width: 18rem;
  text-align: center;
  font-weight: 600;
`;

export const HeaderRow = styled.div`
  padding-bottom: 1.25rem;
`;

export const RaceSelect = styled(Select)`
  background-color: ${Color.blueHue5};
  border-radius: 3px;
  ${standardWidth}
  ${standardHeight}
  border-style: solid;
  border-color: darkgrey;
  border-width: thin;
`;

export const ContainerDiv = styled.div`
  position: relative;
`;

export const AbsoluteContainer = styled.div`
  position: absolute;
  padding: 0.75rem 0 0 0.5rem;
  z-index: 10;
`;

export const OkayDiv = styled.div`
  margin-left: auto;
  margin-right: auto;
  width: 20rem;
  margin-bottom: 1rem;
`;

export const StyledCheckbox = styled(Checkbox)`
  word-wrap: break-word;
  left: 0;
`;

export const StyledMenuItem = styled(MenuItem)`
  && {
    padding-left: 0;
    padding-right: 0;
  }
`;
